import Button from "../../../components/button";
import styles from "./styles.module.css";

const Header = ({ handleAddNewUser }) => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Gestión de Usuarios</h3>
      <Button variant="outline" onClick={handleAddNewUser}>
        Registrar nuevo usuario
      </Button>
    </div>
  );
};

export default Header;
